export const getNetworkMassMailSegmentsEndpoint = () => `Network/MassMail/Segment`;